import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import "./FloatingButtons.css";

const FloatingButtons = () => {
  const [show, setShow] = useState(false);

  return (
    <>
    
      {/* WhatsApp */}
      <a
        href="https://wa.me/256775203734"
        target="_blank"
        rel="noopener noreferrer"
        className="floating-btn whatsapp"
      >
        <i className="bi bi-whatsapp"></i>
      </a>

      {/* Message Button */}
      <div className="floating-btn message" onClick={() => setShow(true)}>
        <i className="bi bi-chat-dots"></i>
        <span className="badge-flot">1</span>
      </div>

      {/* MODAL */}
      <Modal
        show={show}
        onHide={() => setShow(false)}
        centered
        dialogClassName="chat-modal"
      >
        {/* HEADER */}
        <Modal.Header closeButton className="chat-header">
          <Modal.Title>Father’s House Church Resort</Modal.Title>
        </Modal.Header>

        {/* BODY */}
        <Modal.Body className="chat-body">
          <div className="bot-msg">
            Hi! I'm your virtual assistant and can help with rates,
            availability, and answer any questions.
          </div>

          <div className="bot-msg">How can I help?</div>

          <div className="chat-actions">
            <button>Rates</button>
            <button>Photos</button>
            <button>Location</button>
          </div>
        </Modal.Body>

        {/* FOOTER */}
        <Modal.Footer className="chat-footer">
          <input type="text" placeholder="Type a message..." />
          <Button>Send</Button>
        </Modal.Footer>
      </Modal>
      
    </>
  );
};

export default FloatingButtons;